import React from 'react';

import { LoginForm } from './LoginForm';
import { StaffMaster } from './StaffMaster';
import ReserveTableAM from './ReserveTable'; /* 20241031 */
import ReserveTablePM from './ReserveTablePM'; /* 20241031 */


// reducer

const ActionType = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    NORMAL: "NORMAL",
    PM: "PM", /* 20241031 */
    MASTER: "MASTER",
}

const initialState = {
    loggedIn: false,
    masterMode: false,
    page: "AM", /* 20241031 */

    id: null,
    code: "",
    name: "",
    auth: "",

    curr: null,
    curr_en: "",
    curr_cc: "c1",
    curr_ct: "normal",
}

const reducer = (state, action) => {
    switch(action.type) {
    case ActionType.LOGIN:
        return { ...state, ...action.payload, loggedIn: true, masterMode: false, page: "AM", curr: new Date() }; /* 20241031 */
    case ActionType.LOGOUT:
        return { ...initialState };
    case ActionType.NORMAL:
        return { ...state, masterMode: false, page: "AM", curr: action.curr, curr_en: action.curr_en, curr_cc: action.curr_cc, curr_ct: action.curr_ct }; /* 20241031 */
    case ActionType.PM: /* 20241031 */
        return { ...state, masterMode: false, page: "PM", curr: action.curr, curr_en: action.curr_en, curr_cc: action.curr_cc, curr_ct: action.curr_ct }; /* 20241031 */
    case ActionType.MASTER:
        return { ...state, masterMode: true };
    default: break;
    }
}

// context

export const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();

// custom hooks

export const useAuth = () => {
    const state = React.useContext(AuthStateContext);
    const dispatch = React.useContext(AuthDispatchContext);

    const logon = (id, usercd, usernm, auth) => dispatch({
        type: ActionType.LOGIN,
        payload: {
            id, code: usercd, name: usernm, auth: auth,
        }
    });
    const logoff = () => dispatch({ type: ActionType.LOGOUT });
    const modeNormal = () => dispatch({ type: ActionType.NORMAL });
    const modeAm = (curr, en, cc, ct) => dispatch({ type: ActionType.NORMAL, curr: curr, curr_en: en, curr_cc: cc, curr_ct: ct }); /* 20241031 */
    const modePm = (curr, en, cc, ct) => dispatch({ type: ActionType.PM, curr: curr, curr_en: en, curr_cc: cc, curr_ct: ct }); /* 20241031 */
    const modeMaster = () => dispatch({ type: ActionType.MASTER });

    return { state, logon, logoff, modeNormal, modeMaster, modeAm, modePm }; /* 20241031 */
}


export const AuthProvider = ({children}) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    // return (
    //     <AuthStateContext.Provider value={state}>
    //         <AuthDispatchContext.Provider value={dispatch}>
    //             {state.loggedIn===true ? ( state.masterMode ? <StaffMaster/> : <>{children}</> ) : <LoginForm/>}
    //         </AuthDispatchContext.Provider>
    //     </AuthStateContext.Provider>
    // );
    return (
        <AuthStateContext.Provider value={state}>
            <AuthDispatchContext.Provider value={dispatch}>
                {state.loggedIn===true ? ( state.masterMode ? <StaffMaster/> : ( state.page==="AM"? <ReserveTableAM />: <ReserveTablePM />) ) : <LoginForm/>}
            </AuthDispatchContext.Provider>
        </AuthStateContext.Provider>
    );
}
